import { CommissionStructuresListPage, type CommissionListConfig } from '@/pages/CommissionStructures/List'
import { PartnerCommissionStructuresService } from '@/services/modules/CommissionStructuresService'

/**
 * Modelos de comissão do PARCEIRO — mesmo CRUD do admin, porém com as estruturas
 * privadas dele (owner = ele). Usadas só para comissionar a rede dele.
 */
const PARTNER_CFG: CommissionListConfig = {
  service: PartnerCommissionStructuresService,
  title: 'Modelos de comissão',
  subtitle: 'Estruturas de comissão da sua rede (somente suas)',
  crumbs: [{ label: 'Comercial' }, { label: 'Modelos de comissão' }],
  newPath: '/partner/commission-models/novo',
  editPath: (id) => `/partner/commission-models/${id}/editar`,
  tableId: 'partner.commission-structures',
  exportFilename: 'modelos-comissao',
}

export function PartnerCommissionModelsPage() {
  return <CommissionStructuresListPage cfg={PARTNER_CFG} />
}

export default PartnerCommissionModelsPage
